import React, { useEffect, useState } from "react";
import axios from "axios";
import CustomSelect from "./customSelect";

const AvailableUnit = () => {
  const [propertyData, setPropertyData] = useState([]);
  const [propertyTypes, setPropertyTypes] = useState([]);
  const [selectedType, setSelectedType] = useState("All");
  const [selectedFloor, setSelectedFloor] = useState("");
  const [sortPriceAsc, setSortPriceAsc] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    axios
      .get(`https://centralapi.greengroup.ae/api/property/getMarketingListAndTags?listingId=66cc6ee72d89ac71ebca497c`)
      .then((response) => {
        const types = response.data.body.map((item) => ({
          name: item._id,
          tags: item.tags || [],
        }));
        // Make "All" an object so all options have the same structure.
        setPropertyTypes([{ name: "All" }, ...types]);
      })
      .catch((error) => {
        console.error("There was an error fetching the unit types!", error);
      });

    fetchProperties("All", "");
  }, []);

  const fetchProperties = (type, floor) => {
    const listingId = "66cc6ee72d89ac71ebca497c"; // fixed listingId

    axios
      .get(
        `${process.env.REACT_APP_API_URL}property/getAllProperties?listingId=${listingId}&floor=${floor}&unitTitle=&marketing=${type === "All" ? "" : type}`
      )
      .then((response) => {
        setPropertyData(response.data.body);
      })
      .catch((error) => {
        console.error("❌ Error fetching property data!", error);
      });
  };

  const handleTypeChange = (type) => {
    setSelectedType(type.name);
    fetchProperties(type.name, selectedFloor);
  };

  const handleFloorChange = (floor) => {
    setSelectedFloor(floor);
    fetchProperties(selectedType, floor);
  };

  const handleSortChange = (event) => {
    const isChecked = event.target.checked;
    setSortPriceAsc(isChecked);
    if (isChecked) {
      // Use a copy of propertyData when sorting
      setPropertyData([...propertyData].sort((a, b) => a.price - b.price));
    } else {
      fetchProperties(selectedType, selectedFloor);
    }
  };

  const handleDropdownToggle = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown); // Toggle dropdown
  };

  return (
    <div className="main-bg">
      <div className="container">
        <div className="main-div-available-unit">
          <div className="content-main-div">
            <div className="available-unit-left-side-div">
              <div className="text-div">
                <h1>Available Units</h1>
              </div>
              <div className="select-option-div">
                <div className="floo-select-div">
                  <CustomSelect
                    options={[
                      "",
                      "1",
                      "2",
                      "3",
                      "4",
                      "5",
                      "6",
                      "7",
                      "8",
                      "9",
                      "10",
                      "11",
                      "12",
                      "13-14",
                      "15-16",
                      "17-18",
                      "19-20",
                      "22-23",
                      "24-25",
                      "26-27",
                      "28-29",
                      "30-31",
                      "32-33",
                      "34-35",
                      "36-37",
                      "38-39",
                    ]}
                    selectedValue={selectedFloor || "Floor Selection"}
                    onChange={handleFloorChange}
                    isOpen={openDropdown === "floor"}
                    onToggle={() => handleDropdownToggle("floor")}
                  />
                </div>
                <div className="unit-selection-div">
                  <CustomSelect
                    options={propertyTypes}
                    selectedValue={selectedType || "All"}
                    onChange={handleTypeChange}
                    isOpen={openDropdown === "type"}
                    onToggle={() => handleDropdownToggle("type")}
                  />
                </div>
                <div className="sort-option-div">
                  <label className="lable-checkbox-style">
                    <input
                      className="checkout-style"
                      type="checkbox"
                      checked={sortPriceAsc}
                      onChange={handleSortChange}
                    />
                    Sort by Price Lowest to Highest
                  </label>
                </div>
              </div>
            </div>
            <div className="available-unit-right-side-div">
              <table className="available-units-table">
                <thead>
                  <tr>
                    <th>FLOOR</th>
                    <th>UNIT NUMBER</th>
                    <th>TYPE</th>
                    <th>SIZE (SQFT)</th>
                    <th>PRICE</th>
                  </tr>
                </thead>
                <tbody>
                  {propertyData.filter((property) => property.status === "available").length > 0 ? (
                    propertyData
                      .filter((property) => property.status === "available")
                      .map((property, index) => (
                        <tr
                          key={index}
                          onClick={() =>
                            (window.location.href = `https://autographiseries.greengroup.ae/unit-lay-out/${property.floor}/${property.unitNumber}`)
                          }
                        >
                          <td>Floor {property.floor}</td>
                          <td>{property.unitTitle}</td>
                          <td>{property.marketing}</td>
                          <td>{property.totalAreaInSqft} (Sqft)</td>
                          <td>AED {Math.floor(property.price).toLocaleString()}</td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td colSpan="5">No data available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AvailableUnit;
